/**
 * Custom labels for specific filter operators.
 * Operators not listed here will use the default transformation:
 * lowercase -> replace underscores with spaces -> capitalize each word
 */
const OPERATOR_LABEL_OVERRIDES: Record<string, string> = {
  SL_IS_UNIQUE: 'Is Unique In SL List',
}

/**
 * Default transformation for operator labels when no override exists
 */
const defaultTransformation = (operatorType: string): string => {
  return operatorType
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b(\w)/g, (char) => char.toUpperCase())
}

/**
 * Get the display label for a filter operator.
 * Uses custom mapping if available, otherwise applies default transformation.
 *
 * @param operatorType - The operator type from the API (e.g., "SL_IS_UNIQUE")
 * @returns The display label for the operator (e.g., "Is Unique In SL List")
 */
export const getOperatorLabel = (operatorType: string): string => {
  return (
    OPERATOR_LABEL_OVERRIDES[operatorType] ??
    defaultTransformation(operatorType)
  )
}
